const JSONLD_ATTR = 'data-seo-jsonld';

export interface JsonLdScript {
  id: string;
  data: Record<string, unknown>;
}

export function setJsonLd(scripts: JsonLdScript[]): void {
  document.head
    .querySelectorAll(`script[${JSONLD_ATTR}]`)
    .forEach((el) => el.remove());

  scripts.forEach(({ id, data }) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute(JSONLD_ATTR, id);
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  });
}